import {
  Component,
  ElementRef,
  inject,
  model,
  OnInit,
  Renderer2,
  TemplateRef,
  Type,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import {
  NgbAlert,
  NgbAlertModule,
  NgbDropdown,
  NgbDropdownButtonItem,
  NgbDropdownItem,
  NgbDropdownMenu,
  NgbDropdownToggle,
  NgbNav,
  NgbNavChangeEvent,
  NgbNavItem,
  NgbNavLink,
  NgbNavModule,
  NgbNavOutlet,
} from '@ng-bootstrap/ng-bootstrap';
import * as uuid from 'uuid';
import { Pagination } from '@core/interfaces/pagination';
import { ITEMS_PER_PAGE } from '@core/constants';
import { SelectOptions } from '@shared/components/select/select.component';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateService } from '@ngx-translate/core';
import { NgComponentOutlet } from '@angular/common';
import { NavEntry } from '@core/interfaces/nav-entry';

export class NavOptions {
  id?: string = uuid.v4();
  entries?: NavEntry[];
  onSelect?: (value: any, nav: NgbNav) => any;

  constructor(args?: NavOptions) {
    this.id = args?.id || this.id;
    this.entries = args?.entries || [];
    this.onSelect = args?.onSelect;
  }
}

@UntilDestroy()
@Component({
  selector: 'ncp-nav',
  imports: [
    NgbNav,
    NgbNavItem,
    NgbNavOutlet,
    NgbNavModule,
    NgbAlertModule,
    NgComponentOutlet,
    NgbDropdown,
    NgbDropdownMenu,
    NgbDropdownItem,
    NgbDropdownToggle,
  ],
  templateUrl: './nav.component.html',
  styleUrl: './nav.component.scss',
})
export class NavComponent implements OnInit {
  private readonly translate = inject(TranslateService);
  protected translations = this.translate.instant('nav');
  protected renderer2 = inject(Renderer2);
  @ViewChild('nav') public nav!: NgbNav;
  @ViewChild('ddButton') public ddButton!: ElementRef;
  active = '0';
  ddActiveTitle: string = '';
  _index: number = 0;
  options = model(new NavOptions());

  ngOnInit(): void {
    this.translate.onLangChange.pipe(untilDestroyed(this)).subscribe((event) => {
      this.translations = this.translate.instant('nav');
    });
  }

  onNavChange(changeEvent: NgbNavChangeEvent) {
    changeEvent.preventDefault();
    if (this.options().onSelect) {
      this.options().onSelect?.(changeEvent.nextId, this.nav);
    }
    if (changeEvent.nextId === 1) {
    }
  }

  get index() {
    return this._index;
  }

  set index(index: number) {
    this._index = index;
  }

  setIndex(index: number) {
    this._index = this._index + 1;
    return this._index;
  }

  changeTab(options: NavEntry, tab: string) {
    if (this.ddButton) {
      this.active = tab;
      if (tab.includes('-')) {
        this.renderer2.addClass(this.ddButton.nativeElement, 'active');
        this.ddActiveTitle = this.translations[options.label];
        //this.ddButton.nativeElement.classList.add('active');
      } else {
        this.renderer2.removeClass(this.ddButton.nativeElement, 'active');
        this.ddActiveTitle = '';
        //this.ddButton.nativeElement.classList.remove('active');
      }
    }
  }

  protected readonly Object = Object;
}
